import React from 'react';

import { Container } from 'common/components/Layout/Layout';

import ContentBar from 'common/components/Placeholder/components/ContentBar/ContentBar';
import TextBlock from 'common/components/Placeholder/components/TextBlock/TextBlock';

import styles from './BackgroundWithCite.module.scss';

const FullWidthBackground = () => (
  <div className={styles.FullWidthBackground}>
    <Container className={styles.PlaceholderContainer}>
      <div className={styles.CiteBox}>
        <TextBlock
          rows={8}
          color={styles.PlaceholderDefaultColor}
          className={styles.TextBlock}
        />
        <div className={styles.PersonBox}>
          <ContentBar className={styles.Image} />
          <TextBlock
            rows={3}
            color={styles.PlaceholderDefaultColor}
            className={styles.TextBlock}
          />
        </div>
      </div>
    </Container>
  </div>
);

export default FullWidthBackground;



// WEBPACK FOOTER //
// ./src/common/components/Placeholder/components/BackgroundWithCite/BackgroundWithCite.js